import { useCallback, useState } from "react";

const RANGE_PRESETS = [
  { label: "7d", days: 7 },
  { label: "30d", days: 30 },
  { label: "90d", days: 90 },
  { label: "1y", days: 365 },
];

function defaultRange(days = 30) {
  const end = new Date();
  const start = new Date(end.getTime() - days * 24 * 60 * 60 * 1000);
  return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
}

export function useCasaMapaAnalyticsRange(initialDays = 30) {
  const [range, setRange] = useState(() => defaultRange(initialDays));
  const [activePreset, setActivePreset] = useState("30d");

  const handlePreset = useCallback((preset) => {
    setActivePreset(preset.label);
    setRange(defaultRange(preset.days));
  }, []);

  const updateStartDate = useCallback((startDate) => {
    setRange((current) => ({ ...current, startDate }));
    setActivePreset("");
  }, []);

  const updateEndDate = useCallback((endDate) => {
    setRange((current) => ({ ...current, endDate }));
    setActivePreset("");
  }, []);

  return {
    range,
    activePreset,
    presets: RANGE_PRESETS,
    handlePreset,
    updateStartDate,
    updateEndDate,
  };
}
